import { Theme } from "@mui/material";
import { DateTime } from "luxon";
import {
  holidays2025,
  holidays2026,
  holidays2027,
  SchedulePublicHolidays,
  SchedulePublicHolidayType
} from "../../schedule-calendar-holidays";
import { getHolidayEventColor, getTodayCellColor } from "./schedule-calendar-colors";

// filtering only federal public holidays for now
const ALL_PUBLIC_HOLIDAYS: SchedulePublicHolidays[] = [
  ...holidays2025,
  ...holidays2026,
  ...holidays2027
].filter(holiday => holiday.type === SchedulePublicHolidayType.FEDERAL);

/** @deprecated currently the calendar box displays only today */
export function generateScheduleColor({ theme }: { theme: Theme }) {
  const todayBgColor = getTodayCellColor(theme);
  const holidayBgColor = getHolidayEventColor(theme);
  const todayDateISO = DateTime.now().toISODate();

  // Use a map so overlapping dates (e.g. today is also a holiday) collapse to one config
  const colorMap = new Map<
    string,
    { date: string; background?: string; highlight?: string; title?: string }
  >();

  ALL_PUBLIC_HOLIDAYS.forEach(holiday => {
    colorMap.set(holiday.date, {
      date: holiday.date,
      background: holidayBgColor,
      title: holiday.names.de
    });
  });

  const existingHoliday = colorMap.get(todayDateISO);

  if (existingHoliday) {
    // keep the holiday background but also highlight the cell so "today" is visible
    colorMap.set(todayDateISO, {
      ...existingHoliday,
      highlight: todayBgColor
    });
  } else {
    colorMap.set(todayDateISO, { date: todayDateISO, background: todayBgColor });
  }

  return Array.from(colorMap.values());
}

export function generateTodayColor({ theme }: { theme: Theme }) {
  return [{ date: DateTime.now().toISO(), background: getTodayCellColor(theme) }];
}
